import { NodeType } from '@/features/screenplay/components/editor/nodes/NodeType'
import { EditorConfig, LexicalEditor, type NodeKey } from 'lexical'
import { BaseNode, SerializedBaseNode } from './BaseNode'
export class SceneNode extends BaseNode {
    next = NodeType.Action
    enableSuggestions = true
    suggestionPlacement = 'bottom-start'
    editor: LexicalEditor | undefined = undefined
    static getType(): string {
        return 'scene'
    }

    static clone(node: SceneNode): SceneNode {
        return new SceneNode(node.id, node.__key)
    }

    constructor(id: string, key?: NodeKey) {
        super(id, key)
    }

    createHtmlElement(editor: LexicalEditor): HTMLElement {
        const siNo = this.findSiNo()
        const dom = document.createElement('div')
        dom.id = `scene-${this.id}`
        dom.className = 'scene node-style-common jumptarget relative avoid-page-break' // Make the container relative

        const content = document.createElement('span')
        content.className = 'content'
        const sceneIdSpan = document.createElement('span')
        sceneIdSpan.className = 'absolute -left-[25px]'
        sceneIdSpan.textContent = `${(siNo ?? 0) + 1}.`

        dom.append(sceneIdSpan, content)

        return dom
    }

    findSiNo(): number {
        const parent = this.getParent()
        if (!parent) return -1

        let idx = 0
        for (const child of parent.getChildren()) {
            if (child.getType() === NodeType.Scene) {
                if (child.is(this)) return idx
                idx++
            }
        }
        return -1
    }

    static importJSON(jsonNode: SerializedBaseNode): SceneNode {
        return new SceneNode(jsonNode.id)
    }

    static importDOM(): null {
        return null
    }

    updateDOM(prevNode: SceneNode, dom: HTMLElement, config: EditorConfig): boolean {
        return true
    }
}
